<template>
    <ul id="list-tasks">
      <li>
        <div id='oblea'>

          <div id='s1'>
            <img :src="imagenProducto" style="height: 52px" /> 
          </div> 

          <div id='s2'>
            <span id='titulo'>{{nombre}}</span>
          </div> 

          <div id='s22'>
            <div>
              <span class='label'>Precio:</span> 
              <span class='value'>${{item.Precio | formatMoney}}</span>
            </div>
            <div>
              <span class='label'>Subtotal:</span>
              <span class='value'>${{item.Precio*item.Cantidad | formatMoney}}</span>
            </div>
          </div> 

          <div id='s3'>
            <div id='cc'>
              <span id='cantidad'>Cantidad: {{item.Cantidad}}</span> 
            </div> 
          </div> 
          
          <div id='s4'>
          </div> 

        </div>
      </li>
    </ul>
</template>
  



   
  <script>
  import axios from 'axios'


    export default {
      name: 'item-pedidoCms',
      props: ['item'],

      data()  {
        return {
          imagenProducto: null  
        }
      },


      watch: {
        item: {
          immediate: true,
          handler  () {
            this.getImage()
          }
        }
      },


      computed: {
        nombre(){
          if (this.item.ProductoNombre.length > 1)
          {
            return this.item.ProductoNombre
          }
          else
          {
            return this.item.PromocionNombre
          }
        }
      },



      methods: {
        
        downloadImage (imagenId) {
          let config = { method: 'GET',
                         responseType: 'blob',
                         url:'/WebSalesArchivo?ArchivoId='+imagenId+'&Ancho=150',
                         headers: {
                           Token:this.$store.state.user.token,
                           ClientSecret: process.env.CLIENT_SECRET,
                           EmpresaId: process.env.EMPRESA_ID
                         }
                       }
                  axios
                  .request(config)
                  .then(response => {
                    let reader = new FileReader()
                    reader.onload = () => {
                      this.imagenProducto = reader.result
                      var img = {id:imagenId,image:this.imagenProducto} 
                      this.$store.commit('pedido/saveImage',img)   
                    }
                    console.log(response.data)
                    reader.readAsDataURL(response.data)
                  })
                  .catch(err => console.log(err))
        },


        getImage () {
          if (this.item.ProductoId != 0 )
          {
            var producto = this.$store.state.pedido.productos.find(elem => elem.Id === this.item.ProductoId)
            if (producto != null)
            {
              if (producto.ArchivoId != null)
              {
                var img = this.$store.state.pedido.imagenes.find( e => e.id === producto.ArchivoId);
                if (img != null)
                {
                  this.imagenProducto = img.image
                } 
                else
                {
                  this.downloadImage(producto.ArchivoId) 
                }
              }
            }
          }
          else if (this.item.PromocionId != 0 )
          {
            var promocion = this.$store.state.pedido.promociones.find(elem => elem.Id === this.item.PromocionId)
            if (promocion != null)
            {
              if ((promocion.ArchivosId != null) && (promocion.ArchivosId.length > 0))
              {
                var img = this.$store.state.pedido.imagenes.find( e => e.id === promocion.ArchivosId[0]);
                if (img != null)
                {
                  this.imagenProducto = img.image
                } 
                else
                {
                  this.downloadImage(promocion.ArchivosId[0]) 
                }
              }
            }
          }
        }

      }

    }
  </script>
  
  
  <style scoped>
  
  * {
    margin:  0;
    padding: 0;
  }
  
  
  #oblea {
    width: 630px;
    height:70px;
    margin-bottom: 5px;
    background: #ffffff;  
    border-style: solid;
    border-width: 1px;
    border: 1px solid #dddddd;
    box-shadow: 1px 1px 2px #dddddd;
    display: flex;
    align-items: flex-start; 
  }
  
  
#s1{
  width: 10%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
  background: #ffffff;  
}

#s2{
  width: 40%;
  height: 100%;
  display: flex;
  align-items: center; 
  background: #ffffff;  
}

#s22{
  width: 24%;
  height: 100%;
  padding-left: 10px; 
  display: flex;
  flex-direction: column;
  justify-content: center;  
  align-items: flex-start; 
}


#s3{
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
  background: #ffffff;  
}

#s4{
  width: 6%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
  background: #ffffff;  
}
 

#titulo{
  font-size: 13px;
  color: #656E76;
  font-weight: 500;
}


.label{
  font-size: 12px;
  color: #656E76;
  font-weight: 500;
  float: left;
  width: 60px;
  margin-top: 3px;
  margin-bottom: 3px;
}


.value{
  font-size: 12px;
  color: #656E76;
  float: left;
  margin-top: 3px;
  margin-bottom: 3px;
}

#cantidad{
  font-size: 12px;
  color: #656E76;
  margin-top: 3px;
  margin-bottom: 3px;
}

 
  
   </style>


// WEBPACK FOOTER //
// src/components/views/estadoPedido/itemPedidoCms.vue